/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  ListAssistantsRequest,
  ListAssistantsSecurity,
} from "../models/operations/listassistants.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  AssistantsListQueryData,
  buildAssistantsListQuery,
  prefetchAssistantsList,
  queryKeyAssistantsList,
} from "./assistantsList.core.js";
export {
  type AssistantsListQueryData,
  buildAssistantsListQuery,
  prefetchAssistantsList,
  queryKeyAssistantsList,
};

export type AssistantsListQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * listAssistants assistants
 *
 * @remarks
 * List assistants for the current project.
 */
export function useAssistantsList(
  request?: ListAssistantsRequest | undefined,
  security?: ListAssistantsSecurity | undefined,
  options?: QueryHookOptions<AssistantsListQueryData, AssistantsListQueryError>,
): UseQueryResult<AssistantsListQueryData, AssistantsListQueryError> {
  const client = useGramContext();
  return useQuery({
    ...buildAssistantsListQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

/**
 * listAssistants assistants
 *
 * @remarks
 * List assistants for the current project.
 */
export function useAssistantsListSuspense(
  request?: ListAssistantsRequest | undefined,
  security?: ListAssistantsSecurity | undefined,
  options?: SuspenseQueryHookOptions<
    AssistantsListQueryData,
    AssistantsListQueryError
  >,
): UseSuspenseQueryResult<AssistantsListQueryData, AssistantsListQueryError> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildAssistantsListQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

export function setAssistantsListData(
  client: QueryClient,
  queryKeyBase: [
    parameters: {
      gramSession?: string | undefined;
      gramProject?: string | undefined;
    },
  ],
  data: AssistantsListQueryData,
): AssistantsListQueryData | undefined {
  const key = queryKeyAssistantsList(...queryKeyBase);

  return client.setQueryData<AssistantsListQueryData>(key, data);
}

export function invalidateAssistantsList(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: {
      gramSession?: string | undefined;
      gramProject?: string | undefined;
    }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "assistants", "list", ...queryKeyBase],
  });
}

export function invalidateAllAssistantsList(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "assistants", "list"],
  });
}
